function normalizeGmMoq(value) {
  const moq = Number(value);
  return Number.isInteger(moq) && moq >= 1 ? moq : 1;
}

function getGmMoqError(quantity, moq, strings = {}) {
  if (Number.isFinite(quantity) && quantity < moq) {
    return (strings.min_error || 'The minimum quantity is [min].').replace('[min]', moq);
  }

  if (!Number.isInteger(quantity) || quantity % moq !== 0) {
    return (strings.step_error || 'Quantity must be in multiples of [step].').replace('[step]', moq);
  }

  return '';
}

if (typeof window !== 'undefined' && typeof document !== 'undefined' && !window.GMMoq) {
  const getQuantityInput = (productForm, form) => {
    const formQuantity = Array.from(form.elements).find(
      (element) =>
        element instanceof HTMLInputElement &&
        element.name === 'quantity' &&
        !element.hasAttribute('data-gm-moq-fallback')
    );
    if (formQuantity) return formQuantity;
    if (!form.id) return null;

    return document.querySelector(
      `input[name='quantity'][form='${CSS.escape(form.id)}']:not([data-gm-moq-fallback])`
    );
  };

  const configureProductForm = (productForm) => {
    const form = productForm.querySelector('form');
    if (!form) return;

    const moq = normalizeGmMoq(productForm.dataset.gmMoq);
    const quantityInput = getQuantityInput(productForm, form);
    let fallback = form.querySelector('[data-gm-moq-fallback]');

    productForm.dataset.gmMoq = String(moq);

    if (quantityInput) {
      quantityInput.dataset.gmMoq = String(moq);
      quantityInput.dataset.min = String(moq);
      quantityInput.min = String(moq);
      quantityInput.step = String(moq);

      const quantity = Number(quantityInput.value);
      if (getGmMoqError(quantity, moq)) quantityInput.value = String(moq);
      if (fallback) fallback.remove();
      return;
    }

    if (!fallback) {
      fallback = document.createElement('input');
      fallback.type = 'hidden';
      fallback.name = 'quantity';
      fallback.dataset.gmMoqFallback = '';
      form.append(fallback);
    }
    fallback.value = String(moq);
  };

  const configureCartInput = (input) => {
    const moq = normalizeGmMoq(input.dataset.gmMoq);
    input.dataset.gmMoq = String(moq);
    input.dataset.min = String(moq);
    input.min = String(moq);
    input.step = String(moq);
  };

  const configureBulkControl = (control) => {
    const moq = normalizeGmMoq(control.dataset.gmMoq);
    const input = control.querySelector('input[type="number"]');
    if (!input) return;

    control.dataset.gmMoq = String(moq);
    input.dataset.gmMoq = String(moq);
    input.dataset.min = String(moq);
    input.step = String(moq);
  };

  const matchingElements = (root, selector) => {
    const matches = root instanceof Element && root.matches(selector) ? [root] : [];
    return matches.concat(Array.from(root.querySelectorAll?.(selector) || []));
  };

  const configure = (root = document) => {
    matchingElements(root, 'product-form[data-gm-moq]').forEach(configureProductForm);
    matchingElements(root, 'cart-items input[data-gm-moq], cart-drawer-items input[data-gm-moq]').forEach(
      configureCartInput
    );
    matchingElements(root, 'quick-add-bulk[data-gm-moq]').forEach(configureBulkControl);
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const productForm = form.closest('product-form[data-gm-moq]');
      if (!productForm) return;

      configureProductForm(productForm);

      const moq = normalizeGmMoq(productForm.dataset.gmMoq);
      const visibleQuantityInput = getQuantityInput(productForm, form);
      const quantityInput = visibleQuantityInput || form.querySelector('[data-gm-moq-fallback]');
      const quantity = Number(quantityInput?.value);
      const error = getGmMoqError(quantity, moq, window.quickOrderListStrings);

      if (!error) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      productForm.handleErrorMessage?.(error);
      visibleQuantityInput?.focus();
      visibleQuantityInput?.select();
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('cart-items input[data-gm-moq], cart-drawer-items input[data-gm-moq]')) return;

      const moq = normalizeGmMoq(input.dataset.gmMoq);
      const quantity = Number(input.value);
      const error = getGmMoqError(quantity, moq, window.quickOrderListStrings);
      if (!error) return;

      event.stopImmediatePropagation();
      input.value = input.getAttribute('value');
      input.setCustomValidity(error);
      input.reportValidity();
      input.closest('cart-items, cart-drawer-items')?.updateLiveRegions?.(input.dataset.index, error);
      input.select();
      input.addEventListener('input', () => input.setCustomValidity(''), { once: true });
    },
    true
  );

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) configure(node);
      });
    });
  });

  configure();
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.GMMoq = { normalize: normalizeGmMoq, getError: getGmMoqError, configure };
}

if (typeof module !== 'undefined') module.exports = { normalizeGmMoq, getGmMoqError };
